const actionPrefix = "subwayViewSettings";
const CHANGE_DISPLAY = `${actionPrefix}:CHANGE_DISPLAY`;
const CHANGE_TEXT_LINES = `${actionPrefix}:CHANGE_TEXT_LINES`;

export const actionTypes = {
  CHANGE_DISPLAY,
  CHANGE_TEXT_LINES
};

const changeDisplay = display => {
  return {
    type: CHANGE_DISPLAY,
    display
  };
};

const changeTextLines = numTextLines => {
  return {
    type: CHANGE_TEXT_LINES,
    numTextLines
  };
};

export default {
  changeDisplay,
  changeTextLines
};
